import React from 'react';
import { connect } from 'react-redux';
import SettingsPanelSection from '../SettingsPanelSection';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import ImageIcon from '@mui/icons-material/ImageRounded';
import BackgroundMediaPickerDialog from '../../MediaPickers/BackgroundMediaPickerDialog';
import BackdropEditor from '../../components/BackdropEditor';
import { mediaPickerActions } from '../../MediaPickers/store';

class SettingsPanelSectionBackdrop extends React.Component {
    render() {
        const { openBackgroundPicker } = this.props

        return (
            <SettingsPanelSection
                title='Backdrop'
                action={
                    <CircleProgressButton
                        variant='outlined'
                        color='inherit'
                        startIcon={<ImageIcon />}
                        size='small'
                        onClick={openBackgroundPicker}
                    >
                        Change Backdrop
                    </CircleProgressButton>
                }
            >
                {/* Render control for backdrop settings */}
                <BackdropEditor />

                {/* Render dialog for background media */}
                <BackgroundMediaPickerDialog />
            </SettingsPanelSection>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    const openBackgroundPicker = () => dispatch(mediaPickerActions.setProperty('backgroundMediaPickerOpen', true));
    return { openBackgroundPicker }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPanelSectionBackdrop);